package one.healthium.profile.ui.update_name

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.models.UserProfileOptions
import one.healthium.ui.common.event_producer.EventProducer
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class UpdateNameViewModel(
    private val userInteractor: UserInteractor
) : BaseViewModel() {

    private val _state = MutableStateFlow(UpdateNameUiState())
    val state = _state.asStateFlow()

    val uiMessages = UiMessageManager()
    val events = EventProducer<UpdateNameEvent>()

    init {
        userInteractor.observeUser()
            .onEach { userModel ->
                _state.update { state ->
                    state.copy(userModel = userModel)
                }
            }
            .launch()
    }

    fun onNameChanged(value: String) {
        _state.value = _state.value.copy(updatedName = value)
    }

    fun onSaveClicked() {
        if (_state.value.isNameChanged.not()) {
            events.trigger(UpdateNameEvent.OnNameUpdated)
            return
        }

        launchGlobal {
            _state.update { state -> state.copy(loading = true) }
            try {
                userInteractor.updateUserProfile(
                    UserProfileOptions(name = _state.value.updatedName?.trim())
                )
                events.trigger(UpdateNameEvent.OnNameUpdated)
            } catch (e: Exception) {
                Logger.e(e) { "Failed to update name" }
                uiMessages.add(UiMessage.throwable(e))
            } finally {
                _state.update { state -> state.copy(loading = false) }
            }
        }
    }
}